import { audienceSubscriptionTypeFilter } from "@redotech/redo-marketing-common/audience-subscription-type";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getAudienceGrowthAnalytics = {
  name: "getAudienceGrowthAnalytics" as const,
  input: z.object({
    startDate: zExt.instant(),
    endDate: zExt.instant(),
    subscriptionType: createEnum(audienceSubscriptionTypeFilter).default(
      "both",
    ),
  }),
  output: z.object({
    totals: z.object({
      newSubscribers: z.number(),
      previousNewSubscribers: z.number(),
      unsubscribes: z.number(),
      previousUnsubscribes: z.number(),
      spamComplaints: z.number(),
      previousSpamComplaints: z.number(),
    }),
    dailySubscribers: z.array(
      z.object({
        DATE: z.date(),
        EMAIL_SUBSCRIBERS: z.number(),
        SMS_SUBSCRIBERS: z.number(),
        EMAIL_CONFIRMATIONS: z.number(),
        SMS_CONFIRMATIONS: z.number(),
      }),
    ),
    entryPointBreakdown: z.array(
      z.object({ ENTRY_POINT: z.string(), COUNT: z.number() }),
    ),
  }),
};
